import Vue from 'vue'

export default {
    UPDATE_TPLAYLIST (state, value) {
        Vue.set(state, 'tplaylists', value);
    },
    SET_TPLAYLIST (state, value) {
        this.commit('UPDATE_TPLAYLIST', value);
    },
    SET_SELECTED_TPLAYLIST (state,  value ) {
      Vue.set(state, 'selectedTPlaylist', value);
    },
    SET_FILTER_RESULTS (state,  value ) {
      Vue.set(state, 'filterResults', value);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/trendingPlaylists/mutations.js